import React, { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";

const TextBoxControl = ({
  id,
  field,
  value,
  onChange,
  onBlur,
  className,
  disabled,
  maxLength,
  loading,
  type,
  preventPasswordAutoComplete,
  error,
  props,
  onKeyDown,
  'aria-invalid': ariaInvalid,
  'aria-describedby': ariaDescribedBy,
  autoComplete,
}) => {
  const inputRef = useRef();
  const inputId = id ?? "field_txp_" + field.FieldName;
  useEffect(() => {
    inputRef.current.value = value;
  }, [value]);

  return (
    <>
      {field?.DisplayName && (
        <label htmlFor={inputId}>
          {field.DisplayName}
          {field.IsRequired ? " *" : ""}
        </label>
      )}
      <input
        id={inputId}
        placeholder={field.PlaceHolder}
        ref={inputRef}
        onBlur={(context) => onBlur(context, field)}
        defaultValue={value}
        className={
          error === "true" ? `input-error ${className ?? ""}` : className
        }
        disabled={disabled}
        onChange={(e) => onChange(e, field)}
        type={type ?? "text"}
        onWheel={(e) => e.target.blur()}
        maxLength={maxLength}
        autoComplete={autoComplete ?? (preventPasswordAutoComplete ? "new-password" : null)}
        onKeyDown={onKeyDown}
        aria-invalid={ariaInvalid ?? (error === "true" ? true : undefined)}
        aria-describedby={ariaDescribedBy}
      />
    </>
  );
};

export default TextBoxControl;
